import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

class FloatingBox {
  constructor() {
    this.floatingBox = document.getElementsByClassName('floating-box')[0]
    this.trigger = document.getElementById('site-footer')

    this.observe()
  }

  observe() {
    ScrollTrigger.batch(this.trigger, {
      onEnter: () => {
        gsap.to(this.floatingBox, {
          yPercent: 100,
          ease: 'expo.out',
          duration: 1.0,
        })
      },
      onLeaveBack: () => {
        gsap.to(this.floatingBox, {
          yPercent: 0,
          ease: 'expo.out',
          duration: 1.0,
        })
      },
      start: 'top bottom',
    })
  }
}

export default FloatingBox
